// @flow
import * as React from 'react';
import { RouteContext } from '@ta/common.routing';
import BoostTrackingContext from '@ta/cpm.tracking';
import { SponsorshipTrackingContext } from '@ta/trips.tracking';
import DeferredTripModalView from './DeferredTripModalView';

/** Opens a trip modal of the route matches the TripModal arguments  */
const TripModalRoute = () => {
  // Gets the route arguments within the deep-linked route
  const {
    route: { tripModal, isBoosted, ...without },
    navigate,
  } = React.useContext(RouteContext);

  // This is hard to test
  /* istanbul ignore next */
  const close = React.useCallback(() => {
    /* eslint-disable no-restricted-globals */
    if (window?.history?.state != null) {
      /* eslint-disable no-restricted-globals */
      document.dispatchEvent(new CustomEvent('modalClosingEvent'));
      window.history.back();
    } else {
      navigate(without);
    }
    /* eslint-enable no-restricted-globals */
  }, [navigate, without]);

  if (tripModal && typeof tripModal === 'object' && tripModal.id) {
    return (
      <BoostTrackingContext.Provider
        value={{ isBoosted, itemType: 'TRIP', itemId: `${tripModal.id}` }}
      >
        <SponsorshipTrackingContext.Provider value={{ tripId: tripModal.id }}>
          <DeferredTripModalView args={tripModal} onClose={close} />
        </SponsorshipTrackingContext.Provider>
      </BoostTrackingContext.Provider>
    );
  }
  return null;
};

export default TripModalRoute;
